import { SiteAccessDenyCodes } from "../api/siteAccessDenyCodes";
import type { DenialSource } from "./accessDeniedTypes";

const LIFECYCLE_CODES = new Set<string>([
    SiteAccessDenyCodes.siteDisabled,
    SiteAccessDenyCodes.siteDeleted,
    SiteAccessDenyCodes.siteReadOnly,
    SiteAccessDenyCodes.siteNotReportingActive,
    SiteAccessDenyCodes.parentCustomerDisabled,
    SiteAccessDenyCodes.parentCustomerDeleted,
    SiteAccessDenyCodes.parentLocationDisabled,
    SiteAccessDenyCodes.parentLocationDeleted,
]);

const ACTION_CODES = new Set<string>([SiteAccessDenyCodes.insufficientPermission]);

const RESOURCE_CODES = new Set<string>([SiteAccessDenyCodes.siteNotAccessible]);

export function isLifecycleDenyCode(code: string | undefined): boolean {
    return !!code && LIFECYCLE_CODES.has(code);
}

export function isActionDenyCode(code: string | undefined): boolean {
    return !!code && ACTION_CODES.has(code);
}

export function isResourceDenyCode(code: string | undefined): boolean {
    return !!code && RESOURCE_CODES.has(code);
}

export function getDenialSourceForCode(code: string | undefined): DenialSource | undefined {
    if (!code) return undefined;
    if (isLifecycleDenyCode(code)) return "lifecycle";
    if (isActionDenyCode(code)) return "action";
    if (code === "AdminOnly") return "route";
    if (isResourceDenyCode(code)) return "resource";
    return undefined;
}
